import { inject, Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { promiseWrapper } from '@shared/_funtions/promiseWarapper.function';
import { Store } from '@ngrx/store';
import { selectUser } from '@redux/index';
import { filter, take, timeout } from 'rxjs/operators';
import { UserService } from '@shared/_services/user.service';

@Injectable()
export class RoleGuard {
  constructor(
    public auth: AuthService, 
    public router: Router, 
    public store: Store,
    private userService: UserService
  ) {
  }

  async canActivate(route): Promise<boolean> {
    const isAuthenticated = await promiseWrapper(
      this.auth.isAuthenticated$.pipe(take(1))
    );
    
    if (!isAuthenticated) {
      this.router.navigate(['login']);
      return false;
    }
    
    let user = await promiseWrapper(
      this.store.select(selectUser).pipe(take(1))
    );
    
    if (!user) {
      const authUser = await promiseWrapper(
        this.auth.user$.pipe(take(1))
      );
      
      if (authUser?.sub) {
        await this.userService.setUserInfo(authUser.sub);
        
        user = await promiseWrapper(
          this.store.select(selectUser).pipe(
            filter(user => user !== null),
            take(1)
          )
        );
      }
    }
    
    if (user?.roles && route.data.allowedRoles.includes(user.roles[0])) {
      return true;
    } else {
      this.router.navigate(['/portal/user-entry']);
      return false;
    }
  }
}

export const canActivateRole: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return inject(RoleGuard).canActivate(route);
};

@Injectable()
export class GroupsGuard {
  constructor(public store: Store, public router: Router,
  ) {
  }

  async canActivate(route): Promise<boolean> {

    const userRoles = (await promiseWrapper(this.store.select(selectUser)));
    console.log(userRoles);
    if (userRoles?.isMaster) {
      return true;
    } else {
      this.router.navigate(['/portal/user-entry']);
      return false;
    }
  }
}

export const canActivateGroup: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return inject(GroupsGuard).canActivate(route);
};
